import { render, staticRenderFns } from "./userCenter.vue?vue&type=template&id=c145ba68&scoped=true"
import script from "./userCenter.vue?vue&type=script&lang=js"
export * from "./userCenter.vue?vue&type=script&lang=js"
import style0 from "./userCenter.vue?vue&type=style&index=0&id=c145ba68&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c145ba68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c145ba68')) {
      api.createRecord('c145ba68', component.options)
    } else {
      api.reload('c145ba68', component.options)
    }
    module.hot.accept("./userCenter.vue?vue&type=template&id=c145ba68&scoped=true", function () {
      api.rerender('c145ba68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/appRenovation/component/userCenter.vue"
export default component.exports